module.exports = __webpack_public_path__ + "static/media/Gaussian_distribution.26347ebf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Gaussian_distribution.png
// module id = 270
// module chunks = 0